/*
// 页面可见不可见的回调
const handleVisibilityChange = (isVisible: boolean) => {
  if (isVisible) {
    console.log('页面可见，继续执行某些操作')
  } else {
    console.log('页面不可见，暂停某些操作')
  }
}

const { isPageVisible } = usePageVisibility(handleVisibilityChange)
*/
export function usePageVisibility(
  onVisibilityChange?: (isVisible: boolean) => void
) {
  const isPageVisible = ref(true)

  const handleVisibilityChange = () => {
    isPageVisible.value = document.visibilityState === 'visible'

    // 如果传入了回调函数，则执行
    if (onVisibilityChange) {
      onVisibilityChange(isPageVisible.value)
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  return {
    isPageVisible
  }
}
